module.exports = __webpack_public_path__ + "img/cloud-bg1.13bb9f57.png";